import Validatable from "../../../../common/mixins/validatable";
import LicenseBuilderSortable from "../licenseBuilderSortable";
import License from "../license";
import Guid from "~/helpers/guid";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";
import LicenseResourceValidation from "../../../../common/models/navigableValidations/LicenseResourceValidation";
import PublicProfile from "../../../../common/models/publicProfile/publicProfile";

export default class LicenseResource extends Validatable(
  LicenseBuilderSortable
) {
  name: string;
  url: string;

  static repo: IRepo<LicenseResource> = new Repo<LicenseResource>(
    "licenseResources",
    LicenseResource
  );

  constructor(model: License | PublicProfile) {
    super();
    this.defineProperty("client_id", Guid.create());
    this.defineProperty("name", "");
    this.defineProperty("url", "");
    this.defineProperty("sort_order", model.nextSortOrderFor(this.rootName));
    this.parent = model;
    this.license = model;
  }

  get rootName(): string {
    return "resources";
  }

  get displayName(): string {
    return "Resource";
  }

  //******************** VALIDATABLE ********************//
  _validation: LicenseResourceValidation = new LicenseResourceValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      case "url":
        return "Resource URL";
      default:
        return propName;
    }
  }
  //******************** VALIDATABLE END ********************//
}
